import { IconButton } from '@mui/material'
import { flexBox } from 'common/styles/mixins'
import styled from 'styled-components'
import MuiCloseIcon from '@mui/icons-material/Close'
import { TabPanelProps } from './AddRepModal.types'

export const ModalContainer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  z-index: 1200;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  ${({ $isOpen }) =>
    flexBox($isOpen ? 'flex' : 'none', 'unset', 'unset', 'column', 'gap: 10px')}
  background-color: var(--white);
`

export const HeaderContainer = styled.div`
  align-self: stretch;
  ${flexBox('flex', 'center', 'unset', 'row', 'unset')}
  border-bottom: 1px solid var(--grayscale-hover);
  background-color: var(--grayscale-lightest);
  position: relative;
  height: 49px;
`
export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
`
export const CloseIcon = styled(MuiCloseIcon)`
  color: var(--primary);
`
export const TabPanel = styled.div<TabPanelProps>`
  ${({ $isHidden }) =>
    flexBox(
      $isHidden ? 'none' : 'flex',
      'flex-start',
      'center',
      'column',
      'unset'
    )}
  flex: 1;
  overflow: auto;
`
